import { iGV_Database } from "src/app/shared/database/database";
import { Injectable } from "@angular/core";
import { IndexedDBService } from "./indexed-db.service";

@Injectable({
  providedIn: "root",
})
export class DatabaseTileService extends IndexedDBService {
  constructor() {
    super();
  }
  public async getTile(url: string): Promise<any | null> {
    try {
      const entry = await iGV_Database.tilesData.get(url);
      return entry ? entry.data : null;
    } catch (error) {
      console.error(" Error fetching tile from IndexedDB: ", error);
      return null;
    }
  }

  public async saveTile(url: string, data: any): Promise<void> {
    try {
      await iGV_Database.tilesData.put({ url, data });
    } catch (error) {
      console.error(" Error saving tile to IndexedDB: ", error);
    }
  }
}
